export const TEST_ID = 'boundingBoxLabelTriangleIcon';
